// assets/custom-language-switcher-ui.js
(() => {
  'use strict';

  const ROOT_SEL = '[data-custom-language-switcher]';
  const NATIVE_SEL = '[data-custom-language-select]';
  const TOGGLE_SEL = '[data-clswitch-toggle]';
  const MENU_SEL = '[data-clswitch-menu]';
  const ITEM_SEL = '[data-lang]';
  const CODE_SEL = '[data-clswitch-code]';
  const FLAG_SEL = '[data-clswitch-flag]';

  function closeAll(exceptRoot = null) {
    document.querySelectorAll(MENU_SEL).forEach((m) => {
      const r = m.closest(ROOT_SEL);
      if (exceptRoot && r === exceptRoot) return;
      m.hidden = true;
    });
  }

  function getLangFromHTML(root) {
    const flag = root.querySelector(FLAG_SEL);
    return (flag?.getAttribute('data-flag') || 'it').toLowerCase();
  }

  function getLang(root) {
    const sel = root.querySelector(NATIVE_SEL);
    return (window.__clswitch_currentLang || sel?.value || getLangFromHTML(root) || 'it').toLowerCase();
  }

  function setTrigger(root, lang) {
    const l = (lang || 'it').toLowerCase();
    const code = root.querySelector(CODE_SEL);
    const flag = root.querySelector(FLAG_SEL);
    if (code) code.textContent = l.toUpperCase();
    if (flag) flag.setAttribute('data-flag', l);
  }

  function setActive(root, lang) {
    const menu = root.querySelector(MENU_SEL);
    if (!menu) return;
    const l = (lang || 'it').toLowerCase();
    menu.querySelectorAll(ITEM_SEL).forEach((btn) => {
      const b = (btn.getAttribute('data-lang') || '').toLowerCase();
      btn.classList.toggle('is-active', b === l);
    });
  }

  function markReady(root) {
    root.classList.add('clswitch--ready');
    root.classList.remove('clswitch--boot');
  }

  function initAll() {
    document.querySelectorAll(ROOT_SEL).forEach((root) => {
      const lang = getLang(root);
      setTrigger(root, lang);
      setActive(root, lang);
      const menu = root.querySelector(MENU_SEL);
      if (menu) menu.hidden = true;
      markReady(root);
    });
  }

  function toggleMenu(root) {
    const menu = root.querySelector(MENU_SEL);
    if (!menu) return;
    if (menu.hidden) {
      closeAll(root);
      menu.hidden = false;
      const lang = getLang(root);
      setTrigger(root, lang);
      setActive(root, lang);
    } else {
      menu.hidden = true;
    }
  }

  function applyLang(root, lang) {
    const sel = root.querySelector(NATIVE_SEL);
    const menu = root.querySelector(MENU_SEL);
    if (!sel) return;

    const l = (lang || 'it').toLowerCase();
    setTrigger(root, l);
    setActive(root, l);

    sel.value = l;
    sel.dispatchEvent(new Event('change', { bubbles: true }));

    if (menu) menu.hidden = true;
  }

  document.addEventListener('pointerdown', (e) => {
    const root = e.target.closest(ROOT_SEL);
    if (!root) { closeAll(); return; }

    if (e.target.closest(TOGGLE_SEL)) {
      e.preventDefault();
      e.stopPropagation();
      toggleMenu(root);
      return;
    }

    const item = e.target.closest(ITEM_SEL);
    if (item && root.contains(item)) {
      e.preventDefault();
      e.stopPropagation();
      applyLang(root, item.getAttribute('data-lang'));
      return;
    }
  }, true);

  // Quando il core emette la lingua, sincronizza e mostra (no flicker)
  document.addEventListener('clswitch:lang', (e) => {
    const l = (e?.detail?.lang || 'it').toLowerCase();
    document.querySelectorAll(ROOT_SEL).forEach((root) => {
      setTrigger(root, l);
      setActive(root, l);
      markReady(root);
    });
  });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
  else initAll();

  // retry leggero per header/drawer che arrivano dopo
  let tries = 0;
  const t = setInterval(() => {
    initAll();
    if (++tries > 10) clearInterval(t);
  }, 120);
})();